import { createContext } from 'react';
import { Progress } from 'web-library';
import { UpcomingSubjectPaperDetail } from '../../../models/UpcomingSubjectPaper';
import UpcomingSubjectPaper from '../../../modules/upcomingSubjectPaper/components/UpcomingSubjectPaper';
import { useGetUpcomingSubjectPapers } from '../../../api-refactored/upcoming-subject-paper/useGetUpcomingSubjectPapers';

export const UpcomingSubjectPaperContext = createContext<UpcomingSubjectPaperDetail[]>([]);
const UpcomingSubjectPapersBoard = () => {
  const { data: upcomingSubjectPapers } = useGetUpcomingSubjectPapers();

  if (!upcomingSubjectPapers) {
    return <Progress color="secondary" />;
  }

  return (
    <UpcomingSubjectPaperContext.Provider value={upcomingSubjectPapers}>
      <UpcomingSubjectPaper />
    </UpcomingSubjectPaperContext.Provider>
  );
};

export default UpcomingSubjectPapersBoard;
